<template>
    <v-dialog v-model="dialog" max-width="700px" @click:outside="hide">
        <v-card tile flat>
            <v-card-title>
                <v-icon color="black" left size="40">
                    {{ editMode ? 'mdi-file-edit-outline' : 'mdi-file-outline' }}
                </v-icon>
                <div class="title-dialog">
                    {{ editMode ? 'Editar' : 'Subir' }} Resultado de Exámen
                </div>
                <v-spacer/>
                <v-btn icon color="primary" large @click="hide">
                    <v-icon large>mdi-close-circle-outline</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text class="mt-3">
                <v-row>
                    <v-col cols="12">
                        <kimsa-text-field
                            label="Asigna un nombre"
                            outlined
                            flat dense
                            force-value
                            :value="name"
                            @change="name = $event"
                        />
                    </v-col>
                    <v-col cols="12">
                        <kimsa-select
                            label="Asociar a una orden"
                            :items="orders"
                            outlined
                            flat dense
                            force-value
                            :value="order"
                            @change="order = $event"
                            no-object
                        />
                    </v-col>
                    <v-col cols="12">
                        <kimsa-text-field
                            v-if="filename"
                            label="Archivo"
                            outlined
                            flat dense
                            readonly
                            clearable
                            :value="filename"
                            @change="filename = $event"
                        />
                        <v-file-input
                            v-else
                            v-model="file"
                            label="Archivo"
                            outlined
                            flat dense
                            color="secondary"
                            hide-details
                        ></v-file-input>
                    </v-col>
                    <v-col cols="12" align="center">
                        <v-btn @click="save" color="primary" class="normal-btn" depressed :disabled="!valid"
                               :loading="loading">
                            <v-icon>mdi-upload-outline</v-icon>
                            Subir
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>

import {mapMutations, mapState} from "vuex";
import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import KimsaSelect from "@/components/common/inputs/KimsaSelect";
import KimsaUploadFile from "@/components/common/inputs/KimsaUploadFile";
import httpService from "@/services/httpService";

export default {
    name: "UploadHistoryDialog",
    components: {
        KimsaUploadFile,
        KimsaSelect,
        KimsaTextField
    },
    data() {
        return {
            dialog: false,
            loading: false,
            file: null,
            name: '',
            order: null,
            orders: [],
            filename: null,
            editMode: false,
            history: null,
        }
    },
    computed: {
        ...mapState(['dialogActive']),
        valid(vm = this) {
            if (vm.editMode) return !!vm.name
            return !!vm.file && !!vm.name
        },
    },
    async mounted() {
        const vm = this
        await vm.loadOrders()
    },
    methods: {
        ...mapMutations(['setDialogActive']),
        show() {
            const vm = this
            vm.dialog = true
            vm.setDialogActive(true)
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.setDialogActive(false)
            vm.reset()
        },
        reset() {
            const vm = this
            vm.editMode = false
            vm.file = null
            vm.name = ''
            vm.order = null
            vm.filename = null
        },
        async loadOrders() {
            const vm = this
            vm.orders = vm.currentUser.orders.map(order => ({
                id: order.id,
                name: `Orden ${order.id}`
            }))
        },
        async loadHistory(id) {
            const vm = this
            vm.editMode = true
            let response = await httpService.get(`history/${id}`)
            vm.history = response.data.history
            vm.name = vm.history.name
            vm.order = vm.history.order_id
            vm.filename = vm.history.filename
            vm.show()
        },
        async save() {
            const vm = this
            vm.editMode ? console.log('editing') : console.log('saving')
            if (vm.file?.size > 5e6) return vm.toast('El Archivo no puedo ser mayor a 5MB', 'error')

            vm.loading = true
            let payload = new FormData()
            payload.append('name', vm.name)
            if (vm.order) payload.append('order_id', vm.order)
            if (vm.file) payload.append('file', vm.file)

            let response;
            vm.editMode ?
                response = await httpService.putFile(`history/${vm.history.id}/edit`, payload) :
                response = await httpService.postFile('history/create', payload)

            vm.loading = false
            vm.toast(response.data.message)
            vm.hide()
            vm.$emit('success')
        },
    },
    watch: {
        dialogActive(val) {
            if (!val) this.hide()
        },
    }
}
</script>

<style scoped>

.title-dialog {
    color: var(--v-primary-base);
    font-size: 20px;
    font-weight: bold;
}

</style>